/**
 * Modal mit Backdrop + Fokusfalle (useDialog): Escape/Backdrop schließt,
 * initialer Fokus, Fokus-Rückgabe, Scroll-Lock, aria-modal.
 */
import { useRef } from "preact/hooks";
import { useDialog } from "./useDialog";

export function Modal({
  onClose,
  children,
  labelledBy,
}: {
  onClose: () => void;
  children: preact.ComponentChildren;
  labelledBy?: string;
}) {
  const ref = useRef<HTMLElement>(null);
  useDialog(ref, onClose);
  return (
    <div class="chapter-confirm-backdrop" onClick={onClose}>
      <section
        ref={ref}
        class="chapter-confirm glass"
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </section>
    </div>
  );
}
